import { BrokenLinkSvg } from './BrokenLinkSvg';
import { BrokenLinkIcon } from './Page404.style';

export const Icon = () => (
  <BrokenLinkIcon size="100%" title="connect-ring">
    {BrokenLinkSvg}
  </BrokenLinkIcon>
);
